import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import FilePresentRoundedIcon from "@mui/icons-material/FilePresentRounded";
import {
  publicBlueDark,
  publicBlueMain,
} from "../../../Design/SourcesJS/publicTheme";
import ArticleText from "../../Components/Texts/ArticleTextHeader/ArticleText";
import { ARTICLE_TEXT_CLAMP, ARTICLE_TITLE_CLAMP } from "./BlogHomePage-5";
import "./clanekView.css";
import { NAVBAR_SPACE } from "../../Classes/Constants";
import { ArticlesContext, publicTheme } from "../../../../App";
import {
  appDarkBlue,
  articleTitleFont,
} from "../../../Design/SourcesJS/themes";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import BaseButton from "../../../Core/Buttons/BaseButton";
import {
  dateToVisual,
  isValidDate,
  timestampToDate,
} from "../../../Core/Inputs/DateInput";
import { ReactComponent as FbIcon } from "../../../Design/Graphics/svg/Media/icon_facebook.svg";
import { ReactComponent as TwitterIcon } from "../../../Design/Graphics/svg/Media/icon_twitter_x.svg";
import { Motion } from "../../../Core/Motion/Motion";
import { Helmet as RHelmet } from "react-helmet-async";

const articleTest = {
  text: "V nejednom vztahu jsou finance toho druhého záležitostí, o které se nemluví. Situace, kdy po pár měsících společného soužití vyplynula najevo nepříjemná zjištění o závazcích toho druhého se přihodila paní Martině. Více naleznete v článku.",
  section: "dph",
  title: "Prověrka životního partnera",
  imageUrl:
    "https://vyhledavaniexekuci.cz/static/media/FotoPartner.ad0a2c090f358f638b26.webp",
  smallTitle: "Prověrka partnera",
  date: {
    seconds: 1685084997,
    nanoseconds: 709000000,
  },
  id: "mPixETolXfNjbJIWTlrC",
  html: `<p><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">Za svou kariéru jsem se o této skutečnosti přesvědčil již několikrát, ale v povaze mám lidem spíše věřit, než je podezírat. Potom jsem však v rámci svého podnikání narazil na Karla.</span><br><br><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">Karel na mě od začátku působil velice důvěryhodně. Říkal, že provozuje prosperující restauraci a naneštěstí se minulý měsíc nepohodl se svým pravidelným dodavatelem, který mu prý najednou nastavil ceny příliš vysoko. Z vlastní zkušenosti vím, že se takové věci dějí poměrně často. S ohledem na to, že mi Karel svůj podnik ukázal a při té příležitosti mě pozval na společný oběd, jsem jeho nabídku ke spolupráci přijal.</span><br><br><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">První měsíc vypadala spolupráce s Karlem slibně. Karel si u mě objednal zboží za několik set tisíc, což jsem ani nečekal vzhledem k tomu, jak krátce se známe. Veškeré zboží jsem včas doručil a vystavil Karlovi fakturu. Od této chvíle byl však Karel již velmi těžko k zastižení. Tvrdil, že má hodně práce a nemůže se mi neustále věnovat. Rozuměl jsem jeho situaci a přišlo mi samozřejmostí, že mi do konce uplynutí platební lhůty přijdou peníze na účet.</span><br><br><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">Měsíc však uplynul a peníze nikde. A co hůř, Karlovi se už nedalo ani dovolat. Nejdříve jsem váhal, ale pak jsem se rozhodl dát Karla k soudu. Nastal den soudního jednání a Karel k mému překvapení k soudu ani nepřišel. To už mi bylo opravdu divné. Naštěstí mi můj advokát doporučil navrhnout soudci, aby s ohledem na absenci Karla na prvním jednání dal naší straně za pravdu a rozhodl v náš prospěch. Tak se také stalo.</span><br><br><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">Karel i přes prohru u soudu stále nic nezaplatil, a tak jsem předal záležitost soudnímu exekutorovi. Ten mi však za nějakou dobu sdělil, že Karel žádný majetek nemá a restaurace, kterou mi představil, vůbec není psána na jeho jméno. Následně jsem zjistil, že měl Karel již dlouhou dobu před naším seznámením mnoho exekucí a svoje závazky téměř nikdy neuhradil.</span><br><br><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">Příště si tyhle věci</span> <a href="https://vyhledavaniexekuci.cz/" target="_self"><span style="color: blue;background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">vždycky ověřím</span></a><span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">. Zvlášť, když stačí jen nainstalovat</span> <a href="https://vyhledavaniexekuci.cz/app" target="_self"><span style="color: blue;background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">aplikaci do telefonu</span></a> <span style="color: rgb(93,93,93);background-color: rgb(255,255,255);font-size: 15px;font-family: RawlineMedium;">a do pár minut víte, na čem jste.</span>&nbsp;</p>`,
};

const Logo = ({ icon: Icon, sxStyle = {} }) => {
  const editedIcon = React.cloneElement(<Icon />, {
    style: {
      height: "40px",
      width: "40px",
      marginLeft: "15px",
      fill: appDarkBlue,
      ...sxStyle,
    },
  });
  return <>{editedIcon}</>;
};

export default function ClanekView({
  article = articleTest,
  threeArticles = null,
  testArtCount = false,
  podpora = false,
  openArticle = null,
  admin = false,
  loadingSideArticles = false,
}) {
  const data = useContext(ArticlesContext)?.data;
  const tablet = useMediaQuery(publicTheme.breakpoints.only("sm"));
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalArticles, setTotalArticles] = useState(3);

  useEffect(() => {
    console.log();
    let totalIndex = 3;
    try {
      if (article && article.sideArticles) {
        totalIndex = parseInt(article.sideArticles);
      }
    } catch (err) {
      totalIndex = 3;
    }
    console.log(testArtCount);
    if (testArtCount) {
      totalIndex = testArtCount;
      if (totalIndex !== totalArticles) {
        console.log(totalIndex);
        setTotalArticles(totalIndex);
      }
      return;
    }

    let articlesArray;
    if (threeArticles) {
      articlesArray = threeArticles?.length > 0 ? threeArticles : data;
    } else {
      articlesArray = data;
    }
    console.log(articlesArray);

    if (totalIndex < 3 && articlesArray) {
      let contains = false;
      for (let i = 0; i < articlesArray.length; i++) {
        if (
          searchParams.get("clanek") &&
          articlesArray[i]?.id === searchParams.get("clanek")
        ) {
          contains = true;
          break;
        }
      }

      if (contains) {
        totalIndex += 1;
      }
    }
    if (totalIndex !== totalArticles) {
      setTotalArticles(totalIndex);
    }
  }, [threeArticles, article, data, admin]);

  function shareToFacebook() {
    let currentUrl =
      "https://profaktura.cz/" +
      window.location.pathname +
      window.location.search;
    const url = encodeURIComponent(currentUrl); // URL you want to share
    const quote = encodeURIComponent(article.title); // Optional text to pre-fill the post

    // Construct the Facebook share URL
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${quote}`;

    // Redirect the user to the Facebook share dialog
    window.open(facebookShareUrl, "_blank");
  }

  function shareToTwitter() {
    let currentUrl =
      "https://profaktura.cz/" +
      window.location.pathname +
      window.location.search;

    const url = encodeURIComponent(currentUrl); // URL you want to share
    const text = encodeURIComponent(article.title);

    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;

    window.open(twitterShareUrl, "_blank");
  }

  function getDate() {
    const date = article?.date;
    if (!date || !isValidDate(timestampToDate(date))) return null;
    return dateToVisual(timestampToDate(date));
  }

  function areThereSideArticles() {
    return Boolean(threeArticles?.length > 0 || data);
  }
  function getLink(section, article) {
    return `${podpora ? "/podpora" : `/blog`}${section ? `?sekce=${section}${article ? `&clanek=${article}` : ``}` : ""}`
  }

  const GetSideArticles = () => {
    return (
      <>
        {areThereSideArticles() ? (
          (threeArticles?.length > 0 ? threeArticles : data).map(
            (article, index) => (
              <React.Fragment key={"ClViewArticle" + index}>
                {index < totalArticles && (index != 2 || !tablet) && (
                  <>
                    {searchParams.get("clanek") != article.id && (
                      <Grid item xs={24} sm={12} md={24} lg={24} sx={{}}>
                        <ArticleText
                          image={article.imageUrl}
                          blueText={article.smallTitle}
                          title={article.title}
                          text={article.text}
                          buttonText={"Přečíst"}
                          sxTitle={{
                            ...articleTitleFont,
                            ...ARTICLE_TITLE_CLAMP,
                            height: "62px",
                            minHeight: "62px",
                            maxHeight: "62px",
                          }}
                          sxText={{
                            ...ARTICLE_TEXT_CLAMP,
                            height: "66px",
                            minHeight: "66px",
                            maxHeight: "66px",
                          }}
                          sxButton={{ bgcolor: publicBlueMain }}
                          sxProps={{ maxWidth: "100%" }}
                          icon={null}
                          onButtonClick={() => {
                            if (admin) return;
                            if (openArticle) {
                              openArticle(article.section, article.id);
                              return;
                            }
                            navigate({
                              pathname: podpora ? "/podpora" : "/blog",
                              search: `?sekce=${article.section}&clanek=${article.id}`,
                            });
                          }}
                          link={getLink(article.section, article.id)}
                          minutes={podpora ? null : article.sideArticles}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </React.Fragment>
            )
          )
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      {article && (
        <RHelmet>
          <title>{`${article.title} | Profaktura.cz`}</title>
          <meta name="description" content={article.text} />
          <meta property="og:title" content={`${article.title} | Profaktura.cz`} />
          <meta property="og:description" content={article.text} />
          <meta name="twitter:title" content={`${article.title} | Profaktura.cz`} />
          <meta name="twitter:description" content={article.text} />
        </RHelmet>
      )}
      <div
        style={{
          overflowX: "hidden",
          overflowY: "hidden",
          maxWidth: "100%",
          position: "relative",
          minHeight: "100vh",
        }}
      >
        <Container
          maxWidth={areThereSideArticles() ? "lg" : "md"}
          sx={{ mt: "20px" }}
        >
          <Grid container spacing={4} columns={24} sx={{}}>
            <Grid
              container
              item
              columns={24}
              columnSpacing={6}
              rowSpacing={0}
              alignItems="top"
              xs={24}
              sm={24}
              md={areThereSideArticles() ? 16 : 24}
              lg={areThereSideArticles() ? 16 : 24}
              sx={{}}
            >
              <Grid
                item
                xs={24}
                sm={24}
                md={24}
                lg={24}
                sx={{
                  textAlign: "left",
                  height: "100%",
                  overflowWrap: "break-word",
                  overflowX: "hidden",
                  px: { xs: "36px !important", sm: "24px !important" },
                  pr: { xs: "0px !important", sm: "24px !important" },
                  ml: NAVBAR_SPACE,
                  overflow: "hidden",
                }}
              >
                <div
                  className="htmlContainer"
                  dangerouslySetInnerHTML={{ __html: article.html }}
                  style={{ color: 'black' }}
                />
                <Box sx={{ display: "flex", flexDirection: "row", mt: "60px" }}>
                  {!podpora && getDate() && (
                    <BaseButton
                      text={getDate()}
                      sxProps={{
                        maxWidth: "100px",
                        minWidth: "100px",
                        height: "40px",
                      }}
                    />
                  )}

                  <Motion>
                    <Box
                      sx={{
                        height: "min-content",
                        width: "min-content",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        shareToFacebook();
                      }}
                    >
                      <Logo icon={FbIcon} />
                    </Box>
                  </Motion>
                  <Motion>
                    <Box
                      sx={{
                        height: "min-content",
                        width: "min-content",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        shareToTwitter();
                      }}
                    >
                      <Logo icon={TwitterIcon} />
                    </Box>
                  </Motion>
                </Box>
              </Grid>

              {/* INSIDE OF MAIN ARTICLE */}
            </Grid>
            <Grid
              container
              item
              columns={24}
              columnSpacing={4}
              rowSpacing={4}
              xs={24}
              sm={24}
              md={areThereSideArticles() ? 8 : 0}
              lg={areThereSideArticles() ? 8 : 0}
              sx={{ pb: "20px", height: "fit-content", bgcolor: "transparent" }}
            >
              <GetSideArticles />
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
